export const InspectionType = {
  Pickup: 1,
  DropOff: 2,
};

export const InspectionTypeMap = {
  [InspectionType.Pickup]: "Pickup",
  [InspectionType.DropOff]: "Dropoff",
};

export const BOLMediaPurpose = {
  Roof: 1,
  DriverSide: 2,
  PassengerSide: 3,
  CornerFrontPassenger: 4,
  CornerFrontDriver: 5,
  CornerRearPassenger: 6,
  CornerRearDriver: 7,
  Odometer: 8,
  Signatures: 9,
  Additional: 10,
  PowerUnit: 11,
};
